export default {"src":"/_next/static/media/verified.48b00f7a.svg","height":11,"width":12,"blurWidth":0,"blurHeight":0};